import { atomFamily, atomWithStorage } from "jotai/utils";

export const agentExecutionInputAtomFamily = atomFamily((environmentId: string) =>
    atomWithStorage<string>(`environment-agent-input-${environmentId}`, ""),
);
